<template>
  <i-page
    v-show="_total && _total > 0"
    size="small"
    :total="total"
    :current="currentPage"
    :page-size="perPage"
    @on-change="onChangePage"
    style="display: inline-block;"
  />
</template>

<script>
import { Page } from 'view-design'

export default {
  components: {
    'i-page': Page,
  },
  data() {
    return {
      pageStatus: {
        per_page: 20,
        current_page: 1,
        total: null,
      },
    }
  },
  props: {
    total: {
      type: Number,
      default: 0,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
      required: true,
    },
    perPage: {
      type: Number,
      default: 20,
      required: true,
    },
  },
  computed: {
    _total: {
      get() {
        return this.total
      },
      set(val) {
        this.$emit('update:total', val)
      },
    },
    _currentPage: {
      get() {
        return this.currentPage
      },
      set(val) {
        this.$emit('update:currentPage', val)
      },
    },
    _perPage: {
      get() {
        return this.perPage
      },
      set(val) {
        this.$emit('update:perPage', val)
      },
    },
  },
  methods: {
    // ページャークリック処理
    onChangePage(pageNum) {
      this.$emit('search', pageNum)
    },
  },
}
</script>

<style lang="scss"></style>
